import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Select, Form, Row, Col } from 'antd';

const { Option } = Select;

const EmailTemplateFilters = ({ form, onSearch, onReset, initialValues }) => (
  <section className="grey-section">
    <Form form={form} onFinish={onSearch} initialValues={initialValues}>
      <Row gutter={16}>
        <Col span={4}>
          <Form.Item name="param" rules={[{ required: true }]}>
            <Select placeholder="Search by...">
              <Option value="mailType">Name</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item name="val" rules={[{ required: true }]}>
            <Input placeholder="Enter the search term..." />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button htmlType="button" onClick={onReset}>
              Reset
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  </section>
);

EmailTemplateFilters.propTypes = {
  form: PropTypes.object,
  onSearch: PropTypes.func,
  onReset: PropTypes.func,
};

export default EmailTemplateFilters;
